import qs from "qs";
import request from "@/utils/requestSC";

// 查询退换货详情
export async function queryOrderGoodsList(params) {
  return request.post("/rest/order/refund/queryOrderGoodsList", qs.stringify(params));
}

// 提交退款
export async function updateOrderGoods(params) {
  return request.post("/rest/order/refund/updateOrderGoods", params);
}
